export default [
    {
        path: 'partner/transactions',
        name: 'partner.transactions.index',
        component: require('@/views/partner/transactions').default,
        meta: {

        }
    }
]